import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoginService } from "../services/login.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private service: LoginService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method === 'POST' && this.service.getAuthUrl() === req.url) {
            return next.handle(req);
        }

        const authToken = this.service.getAuthToken();
        if (authToken) {
            req = req.clone({
                setHeaders: authToken
            });
        }
        return next.handle(req);
    }

}